// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.user.LeasingUserOuidWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingUserOuidWebApiHandler_getInfoForUser,
  LeasingUserOuidWebApiHandler_getInfoForUser_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetInfoForObfuscatedUserWebApiResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetInfoForUserParams {
  ouid: string;
}

export type LeasingUserOuidWebApiHandler_getInfoForUser_Options = UseQueryOptions<
  GetInfoForObfuscatedUserWebApiResponseDto,
  unknown,
  GetInfoForObfuscatedUserWebApiResponseDto,
  Array<string | GetInfoForUserParams>
>;

const LeasingUserOuidWebApiHandler_getInfoForUser_GetKey = (getParams: GetInfoForUserParams) => [
  LeasingUserOuidWebApiHandler_getInfoForUser_Path,
  getParams,
];

/**
 * get lease and user info for obfuscated user string
 */
export const useLeasingUserOuidWebApiHandler_getInfoForUser = (
  getParams: GetInfoForUserParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserOuidWebApiHandler_getInfoForUser_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: LeasingUserOuidWebApiHandler_getInfoForUser_GetKey(getParams),
    queryFn: () => LeasingUserOuidWebApiHandler_getInfoForUser(getParams, httpClient),
  });
};
useLeasingUserOuidWebApiHandler_getInfoForUser.getKey = LeasingUserOuidWebApiHandler_getInfoForUser_GetKey;
